import { ReactNode } from 'react'

/**
 * Wizard step properties.
 */
export type WizardStep = {
    title: string
    subTitle: string
    content: ReactNode
    actions: WizardStepAction[]
}

/**
 * Wizard step action (button).
 */
export type WizardStepAction = {
    onClick: () => void
    isEnabled: boolean
    buttonText: string
    isOutlined?: boolean
}
